import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, NamedLink, OutsideClickHandler } from '../../../../components';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import { useDispatch } from 'react-redux';
import { deleteSpace, getSpaceMembersList, joinSpace, leaveSpace, toggleCreateComment } from '../../CircleCommunityPage.duck';
import css from './../../CircleCommunityPage.module.css';
import { subscriptionPermissionRequest } from '../../../../ducks/user.duck';
import { FormattedMessage } from '../../../../util/reactIntl';
import { createTicketEventIDs, REQUEST_GROUP_TEMPLATE_ID, REQUEST_JOIN_GROUP_TEMPLATE_ID } from '../../../../util/types';
import MembersComponent from '../../../../components/MembersComponent/MembersComponent';
import { getCommunityUserRole } from '../../../../util/data';
import { onCreateIntercomTicket } from '../../../../util/api';
import { toast } from 'react-toastify';
//latest, popular, oldest, likes, alphabetical, new_activity
const sortOptions = [
  { value: 'latest', label: 'Latest' },
  { value: 'popular', label: 'Popular' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'likes', label: 'Likes' },
  { value: 'alphabetical', label: 'Alphabetical' },
  { value: 'new_activity', label: 'New Activity' },
];

const FeedHeader = props => {
  const {
    is_member,
    isFeedRequested,
    spaceDetail,
    roles,
    isViewDetailedSpace = false,
    singlePostData = {},
    checkCreatePostAuth,
    onToggleCreatePost,
    isFeedPage = false,
    onApplyFilter,
    sort,
    currentUser,
    onRequestSpace,
    currentCommunityMember,
    loading,
    onToggleSpaceMemberList,
    spaceMembersData = {},
    onToggelSearchInGroup,
    groupJoinRequests,
    userModeratorsGroups,
    isOpenElephantModal,
    onSetElephantVerificationModal,
    hideSearch = false,
    hideFeedControls = false,
  } = props;

  const userRoleInGroup = getCommunityUserRole(userModeratorsGroups, spaceDetail?.id);
  const { records = [] } = spaceMembersData || {};
  // user circle id
  const { public_uid } = currentCommunityMember || {};
  const userCircleId = public_uid;

  const { email, profile } = currentUser?.attributes || {};
  const { firstName, lastName } = profile || {};
  const dispatch = useDispatch();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

  const { name: spaceName, id: spaceId, slug } = singlePostData?.space || {};

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const { policies = {} } = spaceDetail || {};
  // const isAdmin = policies?.can_manage_space;
  const isAdmin = ["admin", "moderator"].includes(userRoleInGroup);


  const isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;

  const truncatedName = spaceDetail && spaceDetail?.name?.length > 55 ? `${spaceDetail.name.substring(0, 55)}...` : spaceDetail?.name;
  const isMobileTruncatedName = spaceDetail && spaceDetail?.name?.length > 50 ? `${spaceDetail.name.substring(0, 50)}...` : spaceDetail?.name;


  // Toggle the dropdown visibility
  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

  // Close the dropdown when clicking outside of it
  useEffect(() => {
    const handleOutsideClick = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const handleJoinSpace = () => {
    if (spaceDetail.is_private) {
      alert('This space is private');
      return;
    }

    if (isOpenElephantModal) {
      onSetElephantVerificationModal(true);
      return;
    };

    dispatch(joinSpace(spaceDetail.id));
  };
  const handleLeaveSpace = () => {
    dispatch(leaveSpace(spaceDetail.id));
  };

  const handleDeleteSpace = () => {
    if (!checkCreatePostAuth) {
      dispatch(subscriptionPermissionRequest(true));
      return;
    }
    dispatch(deleteSpace(spaceDetail.id));
  };

  const handleFilterOptions = value => {
    onApplyFilter({ sort: value, spaceId: spaceDetail?.id });
    setIsFilterOpen(false);
    setIsMobileFilterOpen(false);
  };

  const moderatorsEmail = (records || [])
    .filter((item) => item.roles?.moderator)
    .map((item) => ({ email: item.email }))
    .concat((records || []).some((item) => item.roles?.moderator) ? [] : [{ email: process.env.REACT_APP_SENDGRID_ADMIN_RECIVER_EMAIL }]);

  const handleShareGroup = () => {
    const groupUrl = typeof window !== 'undefined' ? window.location.href.replace('/my-group/', '/my-group-public/') : '';

    if (navigator.clipboard && groupUrl) {
      navigator.clipboard.writeText(groupUrl).then(() => {
        toast.success('Link copied to clipboard!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'dark',
        });
      }).catch(err => {
        console.error('Failed to copy:', err);
        toast.error('Failed to copy link', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });
      });
    }
  };

  const handleRequestToJoin = () => {
    if (isOpenElephantModal) {
      onSetElephantVerificationModal(true);
      return;
    };

    // if (!checkCreatePostAuth) {
    //   dispatch(subscriptionPermissionRequest(true));
    //   return;
    // }

    //http://localhost:3000/feed-page/my-group/c/ms-testing/2768420
    const data = {
      userName: firstName + ' ' + lastName,
      userEmail: email,
      groupName: spaceDetail?.name,
      groupId: spaceDetail?.id,
      userId: currentUser?.id?.uuid,
      viewRequestURL: `${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/feed-page/my-group/c/${spaceDetail?.slug || ''}/${spaceDetail?.id}`,
      personalizationsTo: moderatorsEmail.filter((st, i) => i < 10)
    };
    const sendGridMailData = {
      data,
      template_id: REQUEST_JOIN_GROUP_TEMPLATE_ID
    };
    try {
      const intercomReportPostData = {
        userId: currentUser?.id?.uuid,
        userEmail: email,
        groupId: spaceDetail?.id + "",
        groupName: spaceDetail?.name
      };
      const createTicketData = {
        ticketTypeId: createTicketEventIDs["Group Join Request"],
        attributes: intercomReportPostData,
        assignment: true
      };
      // onCreateIntercomTicket(createTicketData)
    } catch (e) {
      console.log(e, '&&& &&& => e');
    }

    return onRequestSpace(sendGridMailData);
  };

  const handleSeeAllMembers = () => {
    const queryParams = {
      page: 1,
      per_page: 5,
      space_id: spaceDetail.id,
    };
    dispatch(getSpaceMembersList(queryParams, true, isAdmin));
    onToggleSpaceMemberList(true);
  };

  const isRequestToJoinSend = groupJoinRequests?.status == "pending";

  return (
    <div className={css.feedNav}>
      <div className={css.feedTitleMobile}>
        {isViewDetailedSpace ? (
          <div>
            {slug && spaceId ? (
              <NamedLink name="MyGroupCommunityPage" params={{ slug, id: spaceId }}>
                <ProfileIconCard type="prev" />{' '}
                <FormattedMessage id="PostViewPage.backText" values={{ spaceName }} />
              </NamedLink>
            ) : null}
          </div>
        ) : spaceDetail?.name ? (
          isMobile ? (
            isMobileTruncatedName
          ) : (
            truncatedName
          )
        ) : (
          <div>
            My feed{' '}
            {isMobile ? (
              <div className={css.mobileFeedTitle}>
                {' '}
                <OutsideClickHandler onOutsideClick={() => isMobileFilterOpen && setIsMobileFilterOpen(false)}>
                  <div data-testid="mobile-filter-dropdown" onClick={() => setIsMobileFilterOpen(!isMobileFilterOpen)}>
                    <ProfileIconCard type="down" />
                  </div>
                  {isMobileFilterOpen && (
                    <div className={css.dropdownMenuMobile}>
                      <ul>
                        {sortOptions.map(option => (
                          <li
                            key={option.value}
                            data-testid={`feed-sort-option-${option.value}`}
                            onClick={() => handleFilterOptions(option.value)}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </OutsideClickHandler>{' '}
              </div>
            ) : null}
          </div>
        )}
      </div>

      {isViewDetailedSpace ? (
        <></>
      ) : is_member || isFeedRequested ? (
        <div className={css.feedFunctions}>
          {/* temporary search bar for api test */}
          {/* {!isFeedRequested ? (
            <div className={css.searchBar} onClick={() => onToggelSearchInGroup(true)}>
              <FormattedMessage id="SearchIngroup.searchBar" />
            </div>
          ) : null} */}
          {!isMobile && !hideSearch ? <div className={css.searchBar} onClick={() => onToggelSearchInGroup(true)}>
            <FormattedMessage id="SearchIngroup.searchBar" />
          </div> : null}
          {!hideFeedControls ? (
            <>
              <OutsideClickHandler onOutsideClick={() => isFilterOpen && setIsFilterOpen(false)}>
                <div
                  data-testid="feed-sort-filter"
                  onClick={() => setIsFilterOpen(!isFilterOpen)}
                  className={css.sortFilter}
                >
                  <ProfileIconCard type="sort" />
                  {sort ? sortOptions.find(option => option.value === sort)?.label : null}
                </div>
                {isFilterOpen && (
                  <div className={css.dropdownMenu}>
                    <ul>
                      {sortOptions.map(option => (
                        <li
                          key={option.value}
                          data-testid={`feed-sort-option-${option.value}`}
                          onClick={() => handleFilterOptions(option.value)}
                        >
                          {option.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </OutsideClickHandler>
              {policies?.can_create_post ? (
                <Button className={css.newButton} onClick={onToggleCreatePost}>
                  + New Post
                </Button>
              ) : null}
            </>
          ) : null}
          {!isFeedPage ? (
            <div className={css.dropdownDots}>
              <OutsideClickHandler onOutsideClick={() => isOpen && setIsOpen(false)}>
                <span data-testid="circle-community-page-header-dropdown-dots" onClick={toggleDropdown} className={css.iconWrapper}>
                  <ProfileIconCard type="dropdown_2" />
                </span>
                {isOpen && (
                  <div className={css.dropdownMenu}>
                    <ul>
                      {/* <li>
                  <ProfileIconCard type="files" />
                  Add Links & Folders
                </li> */}
                      {/* <li className={css.sapce}></li>  */}
                      <li onClick={handleShareGroup} className={css.dropDownButton}>
                        {/* <ProfileIconCard type="share" /> */}
                        Share Group
                      </li>
                      {is_member && !["admin", "moderator"].includes(userRoleInGroup) ? (
                        <>
                          {/* <li onClick={handleSeeAllMembers}>
                            <ProfileIconCard type="follower_black" />
                            <FormattedMessage id="CircleFeedPage.seeMembers" />
                          </li> */}
                          <li onClick={handleLeaveSpace}>
                            {/* <ProfileIconCard type="leave" /> */}
                            <FormattedMessage id="CircleFeedPage.leaveGroup" />
                          </li>
                        </>
                      ) : null}
                      {["admin", "moderator"].includes(userRoleInGroup) ? (
                        <li onClick={handleSeeAllMembers}>
                          {/* <ProfileIconCard type="follower_black" /> */}
                          <FormattedMessage id="CircleFeedPage.manageMembers" />
                        </li>
                      ) : null}
                      {/* {isMobile ? (
                        <li onClick={handleSeeAllMembers}>
                          <MembersComponent records={records} userRole={userRoleInGroup} />
                        </li>
                      ) : null} */}

                      {/* <li className={css.editSpace}>Edit Space</li> */}
                      {/* {["admin"].includes(userRoleInGroup) ? (
                        <li className={css.deleteeditSpace} onClick={handleDeleteSpace}>
                          <FormattedMessage id="CircleFeedPage.deleteGroup" />
                        </li>
                      ) : null} */}
                    </ul>
                  </div>
                )}
              </OutsideClickHandler>
            </div>
          ) : null}
        </div>
      ) : (
        <div>
          {isRequestToJoinSend ?
            <Button className={css.newButton} >
              <FormattedMessage id="CircleFeedPage.requestSendButton" />
            </Button>
            : spaceDetail?.is_private ? (
              <Button className={css.newButton} inProgress={!!loading} onClick={handleRequestToJoin}>
                <FormattedMessage id="CircleFeedPage.requestToJoin" />
              </Button>
            ) : (
              <Button className={css.newButton} onClick={handleJoinSpace}>
                <FormattedMessage id="CircleFeePage.joinNowButton" />
              </Button>
            )}
        </div>
      )}
    </div>
  );
};

export default FeedHeader;
